var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-tile",on:{"click":_vm.throttledOnClick}},[_c('div',{staticClass:"info-tile-content c:row-between-center"},[_c('div',{staticClass:"info-tile-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"info-tile-value"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }